import { render, staticRenderFns } from "./AddCustomerModal.vue?vue&type=template&id=7b831204&scoped=true&"
import script from "./AddCustomerModal.vue?vue&type=script&lang=js&"
export * from "./AddCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b831204",
  null
  
)

export default component.exports